export interface CityData {
  name: string;
  lat: number;
  lng: number;
}

export interface LocationData {
  slug: string;
  name: string;
  state: string;
  region: string;
  description: string;
  highlights: string[];
  content: string[];
  isPrimary: boolean;
  lat: number;
  lng: number;
  cities: CityData[];
}

export const locations: LocationData[] = [
  {
    slug: "houston",
    name: "Houston",
    state: "TX",
    region: "Harris County",
    description:
      "Inka Glass LLC is headquartered in Houston, serving the greater Houston area with expert window replacement and glass replacement for homes and businesses across every neighborhood.",
    highlights: [
      "Window replacement & repair",
      "Broken & foggy glass replaced",
      "Hurricane-rated impact glass",
      "Free written estimates",
    ],
    content: [
      "As our headquarters, Houston is home base for Inka Glass LLC, and our crews cover the whole metro from the Energy Corridor to the Museum District, Midtown, and out toward the Ship Channel. Whether you own a bungalow in the Heights or a high-rise condo downtown, we handle full window replacement, single-pane upgrades, and custom glass work sized to your openings.",
      "Living on the Gulf Coast means your windows take a beating from heat, humidity, and hurricane season. We install energy-efficient, low-E double-pane units that cut cooling bills through those long Houston summers, and we offer impact-rated and storm-rated glass built to stand up to wind-borne debris. Foggy glass between the panes, a failed seal, or a cracked slider all get replaced with clean, code-compliant work.",
      "From Bellaire and West University to Kingwood and Clear Lake, homeowners and property managers trust us for honest assessments and durable results. Our hours are Monday through Friday 9 AM to 5 PM, Saturday 9 AM to 2 PM, and we're closed Sunday, with online messaging support in between. Ready to replace a broken window or upgrade the whole house? Call Inka Glass LLC today at (346) 691-4992 for a free written estimate.",
    ],
    isPrimary: true,
    lat: 29.7604,
    lng: -95.3698,
    cities: [
      { name: "The Heights", lat: 29.7999, lng: -95.4116 },
      { name: "Midtown", lat: 29.7433, lng: -95.3775 },
      { name: "Bellaire", lat: 29.7058, lng: -95.4588 },
      { name: "Clear Lake", lat: 29.5768, lng: -95.1204 },
    ],
  },
  {
    slug: "the-woodlands",
    name: "The Woodlands",
    state: "TX",
    region: "Montgomery County",
    description:
      "Inka Glass LLC brings professional window and glass replacement to The Woodlands, upgrading forested-community homes with energy-efficient, low-E windows built for the Texas climate.",
    highlights: [
      "Energy-efficient window upgrades",
      "Insulated glass unit replacement",
      "Foggy & failed-seal glass fixed",
      "Residential & commercial",
    ],
    content: [
      "The Woodlands is known for its tree-lined villages, and homes in Grogan's Mill, Panther Creek, and Sterling Ridge often have large picture windows framing the greenery. Inka Glass LLC replaces those big panes and everyday sliders alike, matching frame styles so the new glass looks original to the house.",
      "Shaded lots still cook in July, so we steer customers toward low-E, argon-filled double-pane windows that hold conditioned air inside and keep humidity from clouding the glass. When a seal fails and you see that milky haze between panes, we swap the insulated glass unit rather than the whole frame when it makes sense, saving you money.",
      "We also serve retail and office spaces around Market Street and Hughes Landing with storefront and commercial glass replacement. Our schedule runs Monday through Friday 9 AM to 5 PM and Saturday 9 AM to 2 PM, closed Sunday, with messaging support anytime. For a free written estimate in The Woodlands, reach Inka Glass LLC at (346) 691-4992.",
    ],
    isPrimary: false,
    lat: 30.1658,
    lng: -95.4613,
    cities: [
      { name: "Grogan's Mill", lat: 30.1489, lng: -95.4506 },
      { name: "Sterling Ridge", lat: 30.1875, lng: -95.5352 },
      { name: "Panther Creek", lat: 30.1746, lng: -95.4917 },
      { name: "Creekside Park", lat: 30.1394, lng: -95.5344 },
    ],
  },
  {
    slug: "sugar-land",
    name: "Sugar Land",
    state: "TX",
    region: "Fort Bend County",
    description:
      "Serving Sugar Land and its master-planned communities, Inka Glass LLC delivers reliable window replacement and glass repair with energy-efficient upgrades sized to each home.",
    highlights: [
      "Custom-sized window replacement",
      "Double-pane glass upgrades",
      "Broken & cracked glass replaced",
      "Free written estimates",
    ],
    content: [
      "Sugar Land's neighborhoods like First Colony, Telfair, and Riverstone are full of well-kept homes where a single cracked or fogged window can throw off the whole facade. Inka Glass LLC replaces individual panes and full window units, keeping grid patterns and frame colors consistent across your elevation.",
      "Fort Bend summers push A/C systems hard, so we install low-E insulated glass that reflects solar heat and trims your energy costs. If moisture has crept between your panes and left a permanent haze, that's a failed seal, and we replace the glass unit to restore clear views of your yard or the Brazos River bends.",
      "We work with homeowners near Sugar Land Town Square and commercial tenants along Highway 6 for storefront and entry glass. Hours are Monday through Friday 9 AM to 5 PM, Saturday 9 AM to 2 PM, closed Sunday, plus online support. Call Inka Glass LLC at (346) 691-4992 for your free written estimate in Sugar Land.",
    ],
    isPrimary: false,
    lat: 29.6197,
    lng: -95.6349,
    cities: [
      { name: "First Colony", lat: 29.5989, lng: -95.6289 },
      { name: "Telfair", lat: 29.5872, lng: -95.6089 },
      { name: "Riverstone", lat: 29.5497, lng: -95.5697 },
      { name: "New Territory", lat: 29.6206, lng: -95.6858 },
    ],
  },
  {
    slug: "pearland",
    name: "Pearland",
    state: "TX",
    region: "Brazoria County",
    description:
      "Inka Glass LLC serves Pearland with dependable window replacement and glass repair, helping fast-growing neighborhoods stay energy-efficient and storm-ready year-round.",
    highlights: [
      "Storm-rated impact glass",
      "Window replacement & repair",
      "Foggy glass replaced",
      "Residential & commercial",
    ],
    content: [
      "Pearland has grown fast, and communities like Silverlake, Shadow Creek Ranch, and Southdown mix newer builds with established homes that are due for window upgrades. Inka Glass LLC handles everything from a lone broken bedroom window to a full-house replacement with modern low-E units.",
      "Sitting just south of Houston, Pearland catches its share of Gulf storms, so we offer impact-rated and storm-rated glass that helps protect against flying debris and driving rain. For everyday comfort, our energy-efficient double-pane windows knock down the summer heat load and quiet street noise from Broadway and 288.",
      "Businesses near Pearland Town Center count on us for storefront and commercial glass replacement done on schedule. We're open Monday through Friday 9 AM to 5 PM, Saturday 9 AM to 2 PM, closed Sunday, with online messaging in between. Get your free written estimate today by calling Inka Glass LLC at (346) 691-4992.",
    ],
    isPrimary: false,
    lat: 29.5636,
    lng: -95.286,
    cities: [
      { name: "Silverlake", lat: 29.5647, lng: -95.3711 },
      { name: "Shadow Creek Ranch", lat: 29.5586, lng: -95.3903 },
      { name: "Southdown", lat: 29.5497, lng: -95.2894 },
      { name: "West Lea", lat: 29.5719, lng: -95.2794 },
    ],
  },
  {
    slug: "katy",
    name: "Katy",
    state: "TX",
    region: "Harris County",
    description:
      "From Cinco Ranch to Old Katy, Inka Glass LLC provides expert window replacement and glass repair, upgrading homes with energy-efficient panes built for Texas heat.",
    highlights: [
      "Energy-efficient window upgrades",
      "Insulated glass replacement",
      "Sliding door glass repair",
      "Free written estimates",
    ],
    content: [
      "Katy blends historic charm near old downtown with sprawling master-planned communities like Cinco Ranch, Cross Creek Ranch, and Grand Lakes. Inka Glass LLC replaces windows across all of them, from craftsman-style homes to two-story new builds, keeping the look consistent and the fit precise.",
      "West Houston summers are relentless, so we recommend low-E, argon-filled double-pane windows that reflect heat and keep your energy bills in check. Cracked patio slider? Cloudy glass from a blown seal? We replace the glass and hardware so your doors slide smoothly and your views stay clear.",
      "We also serve shops and offices near LaCenterra and the Katy Mills area with commercial glass replacement. Our hours are Monday through Friday 9 AM to 5 PM, Saturday 9 AM to 2 PM, closed Sunday, plus online support anytime. Call Inka Glass LLC at (346) 691-4992 for a free written estimate in Katy.",
    ],
    isPrimary: false,
    lat: 29.7858,
    lng: -95.8245,
    cities: [
      { name: "Cinco Ranch", lat: 29.7355, lng: -95.7674 },
      { name: "Cross Creek Ranch", lat: 29.7008, lng: -95.8794 },
      { name: "Grand Lakes", lat: 29.7461, lng: -95.7439 },
      { name: "Old Katy", lat: 29.7869, lng: -95.8244 },
    ],
  },
  {
    slug: "cypress",
    name: "Cypress",
    state: "TX",
    region: "Harris County",
    description:
      "Inka Glass LLC serves Cypress with professional window and glass replacement, delivering energy-efficient upgrades and fast repairs for its growing family neighborhoods.",
    highlights: [
      "Window replacement & repair",
      "Broken & foggy glass replaced",
      "Low-E energy-efficient panes",
      "Residential & commercial",
    ],
    content: [
      "Cypress has boomed along the 290 corridor, with communities like Bridgeland, Fairfield, and Coles Crossing full of homes ready for window upgrades. Inka Glass LLC replaces aging single-pane windows with modern insulated units and fixes broken glass quickly so your home stays secure.",
      "The northwest Houston heat makes energy efficiency a priority, and our low-E double-pane windows help hold that cool air where it belongs while blocking UV that fades your floors and furniture. When you spot a foggy haze between panes near your Cypress kitchen or living room, that failed seal gets a fresh insulated glass unit.",
      "Local businesses around the Boardwalk at Towne Lake and Fairfield rely on us for storefront and commercial glass replacement. We're open Monday through Friday 9 AM to 5 PM, Saturday 9 AM to 2 PM, closed Sunday, with messaging support available. Reach Inka Glass LLC at (346) 691-4992 for your free written estimate in Cypress.",
    ],
    isPrimary: false,
    lat: 29.9691,
    lng: -95.6972,
    cities: [
      { name: "Bridgeland", lat: 29.9061, lng: -95.7203 },
      { name: "Fairfield", lat: 29.9294, lng: -95.6717 },
      { name: "Coles Crossing", lat: 29.9358, lng: -95.6522 },
      { name: "Towne Lake", lat: 29.9047, lng: -95.6803 },
    ],
  },
  {
    slug: "spring",
    name: "Spring",
    state: "TX",
    region: "Harris County",
    description:
      "Inka Glass LLC provides Spring with trusted window replacement and glass repair, from Old Town charm to Klein-area homes, all with energy-efficient options.",
    highlights: [
      "Insulated window replacement",
      "Cracked & broken glass repair",
      "Foggy glass replaced",
      "Free written estimates",
    ],
    content: [
      "Spring runs from the shops of Old Town Spring to the wooded neighborhoods around Klein and Gleannloch Farms. Inka Glass LLC replaces windows and glass throughout the area, matching frame profiles on older homes and upgrading newer ones to more efficient units.",
      "With Houston-grade heat and humidity, a failed window seal shows up fast as that telltale cloudy film. We replace the fogged insulated glass and install low-E double-pane windows that lower cooling costs and keep interiors comfortable through the long warm season.",
      "Storefronts and offices near the Spring-Cypress and I-45 corridor turn to us for commercial glass replacement handled on time. Hours are Monday through Friday 9 AM to 5 PM, Saturday 9 AM to 2 PM, closed Sunday, plus online messaging support. Call Inka Glass LLC at (346) 691-4992 for a free written estimate in Spring.",
    ],
    isPrimary: false,
    lat: 30.0799,
    lng: -95.4172,
    cities: [
      { name: "Old Town Spring", lat: 30.0743, lng: -95.4108 },
      { name: "Gleannloch Farms", lat: 30.0069, lng: -95.5786 },
      { name: "Klein", lat: 30.0447, lng: -95.5122 },
      { name: "Augusta Pines", lat: 30.0917, lng: -95.5511 },
    ],
  },
  {
    slug: "conroe",
    name: "Conroe",
    state: "TX",
    region: "Montgomery County",
    description:
      "Inka Glass LLC serves Conroe and the Lake Conroe area with dependable window replacement and glass repair, keeping lakeside and in-town homes clear and efficient.",
    highlights: [
      "Window replacement & repair",
      "Lakefront picture-window glass",
      "Foggy & failed-seal glass fixed",
      "Residential & commercial",
    ],
    content: [
      "Conroe stretches from its historic downtown square out to the shores of Lake Conroe, where waterfront homes in April Sound and Bentwater feature big picture windows that deserve crystal-clear glass. Inka Glass LLC replaces those large panes along with standard windows throughout the city.",
      "Lakeside living means intense sun reflection and humidity, so we install low-E insulated glass that cuts glare and heat while resisting the seal failures that cause fogging. Broken sliders, cracked panes, and hazy double-pane units all get replaced with clean, weather-tight work.",
      "We also help downtown Conroe businesses and shops near the Crighton Theatre with storefront glass replacement. Our hours are Monday through Friday 9 AM to 5 PM, Saturday 9 AM to 2 PM, closed Sunday, with online support in between. For a free written estimate in Conroe, call Inka Glass LLC at (346) 691-4992.",
    ],
    isPrimary: false,
    lat: 30.3119,
    lng: -95.4561,
    cities: [
      { name: "April Sound", lat: 30.3697, lng: -95.5711 },
      { name: "Bentwater", lat: 30.4269, lng: -95.5783 },
      { name: "Grand Central Park", lat: 30.2739, lng: -95.4489 },
      { name: "Panorama Village", lat: 30.3767, lng: -95.4919 },
    ],
  },
  {
    slug: "tomball",
    name: "Tomball",
    state: "TX",
    region: "Harris County",
    description:
      "Inka Glass LLC brings professional window and glass replacement to Tomball, blending small-town service with energy-efficient upgrades for homes and Main Street businesses.",
    highlights: [
      "Energy-efficient window upgrades",
      "Broken & foggy glass replaced",
      "Storefront glass replacement",
      "Free written estimates",
    ],
    content: [
      "Tomball keeps its small-town character around the historic depot and Main Street while newer communities like Wildwood at Northpointe and Amira grow on the edges. Inka Glass LLC serves both, replacing windows on established homes and outfitting new construction with efficient glass.",
      "Even north of the city, Houston's heat and storms take a toll. We install low-E double-pane windows that reduce cooling costs and offer impact-rated glass for added protection when Gulf weather turns rough. Fogged panes from broken seals are swapped out for fresh insulated units that restore your view.",
      "Main Street shops and businesses near the Tomball Farmers Market count on us for storefront and entry glass replacement. We're open Monday through Friday 9 AM to 5 PM, Saturday 9 AM to 2 PM, closed Sunday, with messaging support available. Call Inka Glass LLC at (346) 691-4992 for a free written estimate in Tomball.",
    ],
    isPrimary: false,
    lat: 30.0972,
    lng: -95.6161,
    cities: [
      { name: "Wildwood at Northpointe", lat: 30.0472, lng: -95.6206 },
      { name: "Amira", lat: 30.0233, lng: -95.6644 },
      { name: "Willowcreek Ranch", lat: 30.0808, lng: -95.6844 },
      { name: "Rosehill", lat: 30.1256, lng: -95.6772 },
    ],
  },
  {
    slug: "humble",
    name: "Humble",
    state: "TX",
    region: "Harris County",
    description:
      "Inka Glass LLC serves Humble with fast, reliable window replacement and glass repair, keeping northeast Houston homes and businesses secure and energy-efficient.",
    highlights: [
      "Window replacement & repair",
      "Cracked & broken glass replaced",
      "Low-E insulated glass",
      "Residential & commercial",
    ],
    content: [
      "Humble anchors northeast Houston near the airport corridor, with neighborhoods like Fall Creek and Eagle Springs alongside its older established streets. Inka Glass LLC replaces windows and glass across the city, from single broken panes to whole-home upgrades.",
      "Summers here are hot and storm season is real, so we install energy-efficient low-E windows and offer impact-rated glass to help homes stand up to Gulf weather. When condensation collects between your panes and won't wipe away, that's a failed seal we replace with a fresh insulated glass unit.",
      "Retailers and offices near Deerbrook Mall and along FM 1960 rely on us for commercial and storefront glass replacement. Our schedule is Monday through Friday 9 AM to 5 PM, Saturday 9 AM to 2 PM, closed Sunday, plus online messaging support. Reach Inka Glass LLC at (346) 691-4992 for your free written estimate in Humble.",
    ],
    isPrimary: false,
    lat: 29.9988,
    lng: -95.2622,
    cities: [
      { name: "Fall Creek", lat: 29.9367, lng: -95.2361 },
      { name: "Eagle Springs", lat: 30.0111, lng: -95.1972 },
      { name: "Atascocita Shores", lat: 29.9922, lng: -95.1567 },
      { name: "Bordersville", lat: 30.0281, lng: -95.2506 },
    ],
  },
  {
    slug: "kingwood",
    name: "Kingwood",
    state: "TX",
    region: "Harris County",
    description:
      "Known as the Livable Forest, Kingwood trusts Inka Glass LLC for window replacement and glass repair that keeps wooded-lot homes clear, efficient, and storm-ready.",
    highlights: [
      "Picture-window replacement",
      "Foggy glass replaced",
      "Storm-rated impact glass",
      "Free written estimates",
    ],
    content: [
      "Kingwood earned its Livable Forest nickname with greenbelts and tree-shaded villages like Elm Grove, Kings Point, and Bear Branch. Those wooded lots mean lots of glass to enjoy the view, and Inka Glass LLC replaces everything from tall picture windows to standard sashes and sliders.",
      "Sitting along the San Jacinto near Lake Houston, Kingwood knows flooding and storms, so we offer impact-rated and storm-rated glass for extra peace of mind. For everyday comfort, low-E double-pane windows reduce heat gain and keep humidity from clouding your glass with failed-seal fog.",
      "Businesses around Kingwood Town Center depend on us for storefront glass replacement handled cleanly and on time. We're open Monday through Friday 9 AM to 5 PM, Saturday 9 AM to 2 PM, closed Sunday, with online support in between. Call Inka Glass LLC at (346) 691-4992 for a free written estimate in Kingwood.",
    ],
    isPrimary: false,
    lat: 30.0466,
    lng: -95.1996,
    cities: [
      { name: "Elm Grove", lat: 30.0294, lng: -95.1786 },
      { name: "Kings Point", lat: 30.0561, lng: -95.1608 },
      { name: "Bear Branch", lat: 30.0578, lng: -95.2094 },
      { name: "Trailwood", lat: 30.0367, lng: -95.2181 },
    ],
  },
  {
    slug: "atascocita",
    name: "Atascocita",
    state: "TX",
    region: "Harris County",
    description:
      "Inka Glass LLC serves Atascocita with professional window and glass replacement, upgrading lakeside and suburban homes with energy-efficient, storm-ready glass.",
    highlights: [
      "Energy-efficient window upgrades",
      "Broken & foggy glass replaced",
      "Impact-rated storm glass",
      "Residential & commercial",
    ],
    content: [
      "Atascocita hugs the south shore of Lake Houston, with communities like Walden, Eagle Springs, and Atascocita Forest full of homes that make the most of the water views. Inka Glass LLC replaces large lakeside windows and everyday glass alike, keeping frames matched and seals tight.",
      "Waterfront exposure brings sun, humidity, and storm risk, so we install low-E insulated windows that cut heat and glare and offer impact-rated glass for hurricane season. Cloudy panes from broken seals get replaced with clear insulated units, and cracked or shattered glass is handled fast to keep your home secure.",
      "Shops and offices along West Lake Houston Parkway rely on us for commercial and storefront glass replacement. Our hours are Monday through Friday 9 AM to 5 PM, Saturday 9 AM to 2 PM, closed Sunday, with messaging support available. Get your free written estimate by calling Inka Glass LLC at (346) 691-4992.",
    ],
    isPrimary: false,
    lat: 29.9994,
    lng: -95.176,
    cities: [
      { name: "Walden on Lake Houston", lat: 30.0142, lng: -95.1436 },
      { name: "Atascocita Forest", lat: 29.9861, lng: -95.1739 },
      { name: "Eagle Springs", lat: 30.0111, lng: -95.1972 },
      { name: "Pinehurst", lat: 29.9772, lng: -95.1911 },
    ],
  },
  {
    slug: "rosenberg",
    name: "Rosenberg",
    state: "TX",
    region: "Fort Bend County",
    description:
      "Inka Glass LLC serves Rosenberg with honest, dependable window replacement and glass repair, bringing energy-efficient upgrades to its historic and growing neighborhoods.",
    highlights: [
      "Window replacement & repair",
      "Insulated glass replacement",
      "Cracked & foggy glass fixed",
      "Free written estimates",
    ],
    content: [
      "Rosenberg pairs a historic downtown along the railroad with growing communities like Seabourne Meadows and Sunset Crossing. Inka Glass LLC replaces windows across the range, restoring older homes with matched glass and fitting new builds with efficient double-pane units.",
      "Out in Fort Bend, the summer sun is intense, so our low-E, argon-filled windows help hold cooling costs down and keep interiors comfortable. When a seal blows and leaves that foggy film between panes, we replace the insulated glass, and broken or cracked windows get handled quickly to keep your home secure.",
      "Downtown shops near the Rosenberg Railroad Museum and businesses along Highway 59 count on us for storefront glass replacement. We're open Monday through Friday 9 AM to 5 PM, Saturday 9 AM to 2 PM, closed Sunday, plus online support. Call Inka Glass LLC at (346) 691-4992 for a free written estimate in Rosenberg.",
    ],
    isPrimary: false,
    lat: 29.5572,
    lng: -95.8085,
    cities: [
      { name: "Seabourne Meadows", lat: 29.5286, lng: -95.7994 },
      { name: "Sunset Crossing", lat: 29.5808, lng: -95.7936 },
      { name: "Bryan Crossing", lat: 29.5561, lng: -95.8489 },
      { name: "Riverpark West", lat: 29.5892, lng: -95.7583 },
    ],
  },
  {
    slug: "magnolia",
    name: "Magnolia",
    state: "TX",
    region: "Montgomery County",
    description:
      "Inka Glass LLC brings reliable window and glass replacement to Magnolia, serving its country-style homes and growing communities with energy-efficient upgrades.",
    highlights: [
      "Energy-efficient window upgrades",
      "Broken & foggy glass replaced",
      "Sliding door glass repair",
      "Residential & commercial",
    ],
    content: [
      "Magnolia keeps a rural, country feel along FM 1488 and FM 1774 while communities like Mostyn Manor, Audubon, and High Meadow Ranch bring new growth. Inka Glass LLC serves them all, replacing windows on acreage homesteads and modern subdivisions with equal care.",
      "The northwest reach of the metro still gets plenty of Texas heat, so we install low-E double-pane windows that trim energy bills and block UV that fades interiors. Fogged panes from failed seals are swapped for clear insulated units, and cracked sliders or shattered glass get replaced fast to keep your home tight and secure.",
      "Local businesses around downtown Magnolia and the FM 1488 corridor rely on us for storefront and commercial glass replacement. Our hours are Monday through Friday 9 AM to 5 PM, Saturday 9 AM to 2 PM, closed Sunday, with online messaging support in between. Call Inka Glass LLC at (346) 691-4992 for a free written estimate in Magnolia.",
    ],
    isPrimary: false,
    lat: 30.2094,
    lng: -95.7513,
    cities: [
      { name: "Mostyn Manor", lat: 30.2231, lng: -95.6944 },
      { name: "Audubon", lat: 30.2544, lng: -95.6725 },
      { name: "High Meadow Ranch", lat: 30.1583, lng: -95.7442 },
      { name: "Williams Trace", lat: 30.1972, lng: -95.7689 },
    ],
  },
];

export const primaryLocation = locations.find((l) => l.isPrimary) ?? locations[0];
